import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const LineMask = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionLabel = ({ number, children }) => (
  <div className="flex items-center gap-4 mb-6">
    <span className="font-display text-neon text-sm tracking-widest">{number}</span>
    <span className="h-px w-10 bg-neon/40" />
    <span className="text-xs tracking-[0.3em] uppercase font-head font-semibold text-fog">{children}</span>
  </div>
);
